export default __webpack_public_path__ + "static/media/11-59.dcff8a62.png";